import { useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { InputRef } from "antd5";
import { z } from "zod";

import { KeywordSelect } from "components/form_components/keyword_select/KeywordSelect";
import { useFormAutoSubmit } from "../../lib/hooks/useFormAutoSubmit";
import { useDocumentTracking } from "./tracking";

import css from "./FilterForm.module.scss";

export const DocumentViewerFiltersSchema = z.object({
  keywords: z.array(z.string()),
});
export type DocumentViewerFilters = z.infer<typeof DocumentViewerFiltersSchema>;

type FilterFormProps = {
  filters: DocumentViewerFilters;
  onChange: (filters: DocumentViewerFilters) => void;
};

export default function FilterForm({ filters, onChange }: FilterFormProps) {
  const tracking = useDocumentTracking();
  const searchInputRef = useRef<InputRef>(null);

  const { control, watch, getValues, trigger, setValue } = useForm<DocumentViewerFilters>({
    mode: "onChange",
    defaultValues: filters,
  });

  useEffect(() => {
    setValue("keywords", filters.keywords);
  }, [filters.keywords, setValue]);

  useFormAutoSubmit({
    watch,
    getValues,
    trigger,
    onChange: (data) => {
      onChange(data);
      tracking.documentSearched();
    },
  });

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key === "f") {
        event.preventDefault();
        if (searchInputRef.current) {
          searchInputRef.current.input?.click();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <form>
      <KeywordSelect
        name="keywords"
        label=""
        control={control}
        containerClassName={css.keywordFilter}
        ref={searchInputRef}
      />
    </form>
  );
}
